

export const FETCH_VEHICLE_CATEGORY_LIST = {
    START: 'FETCH_VEHICLE_CATEGORY_LIST_START',
    SUCCESS: 'FETCH_VEHICLE_CATEGORY_LIST_SUCCESS',
    ERROR: 'FETCH_VEHICLE_CATEGORY_LIST_ERROR',
  };
  export const TOAST = {
    RESET: 'RESET_TOAST',
  };
  export const FETCH_VEHICLE_CATEGORY_INIT="FETCH_VEHICLE_CATEGORY_INIT"
  export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY =
  'SET_DELETE_CONFIRMATION_POPUP_VISIBILITY';


  
export const INIT_CREATE_VEHICLE_CATEGORY_SCREEN =
'INIT_CREATE_VEHICLE_CATEGORY_SCREEN';

export const CREATE_VEHICLE_CATEGORY = {
START: 'CREATE_VEHICLE_CATEGORY_START',
SUCCESS: 'CREATE_VEHICLE_CATEGORY_SUCCESS',
ERROR: 'CREATE_VEHICLE_CATEGORY_ERROR',
};

export const EDIT_VEHICLE_CATEGORY = {
START: 'EDIT_VEHICLE_CATEGORY_START',
SUCCESS: 'EDIT_VEHICLE_CATEGORY_SUCCESS',
ERROR: 'EDIT_VEHICLE_CATEGORY_ERROR',
};

export const FETCH_VEHICLE_CATEGORY_DETAIL = {
  START: 'FETCH_VEHICLE_CATEGORY_DETAIL_START',
  SUCCESS: 'FETCH_VEHICLE_CATEGORY_DETAIL_SUCCESS',
  ERROR: 'FETCH_VEHICLE_CATEGORY_DETAIL_ERROR',
};
export const EXPORT_VEHICLE_CATEGORY = {
  START: 'EXPORT_VEHICLE_CATEGORY_START',
  SUCCESS: 'EXPORT_VEHICLE_CATEGORY_SUCCESS',
  ERROR: 'EXPORT_VEHICLE_CATEGORY_ERROR',
};

export const VEHICLE_CATEGORYDD = {
  START: 'VEHICLE_CATEGORYDD_START',
  SUCCESS: 'VEHICLE_CATEGORYDD_SUCCESS',
  ERROR: 'VEHICLE_CATEGORYDD_ERROR',
};
export const DELETE_VEHICLE_CATEGORY = {
  START: 'DELETE_VEHICLE_CATEGORY_START',
  SUCCESS: 'DELETE_VEHICLE_CATEGORY_SUCCESS',
  ERROR: 'DELETE_VEHICLE_CATEGORY_ERROR',
};

export const VEHICLE_CATEGORY_SAVE_TABLE_STATE = 'VEHICLE_CATEGORY_SAVE_TABLE_STATE';